import { render, staticRenderFns } from "./ChapterView.vue?vue&type=template&id=beb7365e&scoped=true&"
import script from "./ChapterView.vue?vue&type=script&lang=ts&"
export * from "./ChapterView.vue?vue&type=script&lang=ts&"
import style0 from "./ChapterView.vue?vue&type=style&index=0&id=beb7365e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beb7365e",
  null
  
)

export default component.exports